import React from 'react'
import Layout from '../components/layout'
import Resume from '../components/Resume'
import './portfolio.scss'

import SEO from '../components/SEO'
const ResumePage = () => (
  
    
   
	<Layout>
		
		<SEO title="Work Experience" description="A brief summary of my work experience" />
	<div className="blog-list">
	<main className="portfolio">
		<Resume>
			<p>Here's an overview of some of the things I've worked on
					since I started building software for the web. For more details, download my resume as a PDF</p>
            <p className="portfolio__resume-summary"> <br/><br/><br/>
					<a href="https://drive.google.com/file/d/1VQUG97MXMjPfpc2wm89r0PTa7YbIir_M/view?usp=sharing">
						<svg height="50px" width="50px" alignmentBaseline="central" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 279722 333333" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd">
						<title>Resume</title>
						<path d="M3206 330961c-1889-845-3206-2740-3206-4943V5412C0 2423 2423-1 5413-1h268897c2989 0 5413 2423 5413 5413v292238c0 285-22 566-65 839-751 10652-4221 18974-10471 24917-6230 5923-15005 9235-26380 9880-231 30-467 46-706 46H7684c-1861 0-3504-941-4478-2372zm119996-224952c6688 13947 26962 14437 33366 80-1747-1768-3042-3661-4329-5543-211-309-422-617-636-926-3093 2454-6843 4017-11731 4004-5272-13-9242-2028-12497-5006-196-178-387-360-577-545-465 1296-1058 2845-1693 4291-611 1393-1267 2705-1902 3645zm35246-1472c7137 5040 24502 6259 31164 9974 2213 1234 4213 2806 5821 4930 3352 4426 10213 20508-914 21356h-20917l2572-28797c-5610-1096-11546-1947-17758-5524-3832 16848-29839 19259-37333 450-5570 2807-10988 4409-17461 5410l4030 28459H85204c-11127-847-4267-16930-914-21356 1609-2125 3607-3695 5822-4929 6645-3706 23936-4928 31107-9936 526-792 1096-1945 1641-3190 824-1878 1575-3935 2052-5336-2011-2363-3724-5030-5376-7657l-5438-8646c-1989-2965-3022-5677-3085-7899-29-1047 148-1997 534-2830 406-875 1029-1606 1869-2171 393-265 832-489 1318-673-352-4689-484-10599-257-15545 117-1174 342-2348 670-3522 1390-4965 4874-8961 9187-11707 2377-1513 4983-2659 7703-3428 1722-487-247-4377 1538-4561 8633-887 21376 5364 27404 11885 3020 3267 4913 7597 5323 13326l-339 14112v-1c1507 459 2473 1415 2870 2963 437 1713-38 4131-1491 7428l-4-3c-27 60-57 119-92 177l-6196 10205c-2278 3750-4588 7509-7604 10477 272 390 543 786 813 1183 1229 1795 2463 3600 4052 5208 51 51 96 107 136 164v1zm-40579-35854c-1205 47-2117 296-2741 716-356 239-618 544-785 907-187 403-273 893-257 1457 47 1654 915 3817 2590 6308l24 36 5437 8647c2181 3468 4467 7001 7307 9599 2731 2497 6047 4187 10427 4198 4746 12 8218-1745 11034-4381 2930-2743 5242-6502 7520-10255l6125-10089c1142-2604 1557-4349 1297-5371-156-608-827-906-1973-963-243-12-493-15-746-8-272 8-558 26-856 54-163 15-321 3-472-31-544 30-1106-7-1680-92l2098-9283c-15565 2453-27207-9107-43661-2313l1187 10943c-665 30-1293 7-1876-81v2zm73281 224761c-2959 0-5358-2424-5358-5413s2400-5412 5358-5412h45235c2959 0 5358 2423 5358 5412s-2399 5413-5358 5413h-45235zM45618 253947c-2959 0-5358-2423-5358-5413 0-2989 2399-5412 5358-5412h191233c2959 0 5358 2423 5358 5412s-2399 5413-5358 5413H45618zm877-39497c-2959 0-5358-2423-5358-5412s2399-5413 5358-5413h189889c2959 0 5358 2423 5358 5413 0 2989-2399 5412-5358 5412H46495zm-877-39497c-2959 0-5358-2423-5358-5412s2399-5413 5358-5413h81745c2959 0 5358 2424 5358 5413s-2400 5412-5358 5412H45618zm102591 0c-2959 0-5358-2423-5358-5412s2400-5413 5358-5413h88175c2959 0 5358 2424 5358 5413s-2399 5412-5358 5412h-88175zm120689 122574V10823H10825v311683h231275l112 2c8711-492 15207-2813 19532-6925 4254-4044 6624-10077 7153-18056z" fill-rule="nonzero"/></svg>
					</a>
					
					</p>

				
			
			<Resume.Position
				name="Amazon Web Services"
				link="https://aws.amazon.com/"
				start="February 2019"
			>					
			
				<Resume.Role name="Big Data Cloud Engineer" start="August 2020"/>
				<Resume.Role name="Big Data Cloud Associate" start="July 2019" end="July 2019"/>
				<Resume.Description>
					<p>
					 Help Enterpriese customers with technical engagements by troubleshooting their isssues and technical guidance on the applicability, limitations, and trade offs between a wide set of AWS Big Data Services. 
					 Work with Account managers and Solution Architects in fixing issues related to services like EMR , Glue , Athena , DynamoDb , Redshift . 
					</p>
				</Resume.Description>
				<Resume.Role
					name="Cloud Solution Intern"
					start="July 2018"
					end="May 2019"
				/>
				<Resume.Description>
					<p>
					Created an ETL pipelines using AWS Glue (Spark) to load data into Postgresql database from s3.
					Wrote SQL queries to analyze data and make relevant report as per the business requirement.
					Development of ‘Availability Management’ Tool
					</p>
				</Resume.Description>
			</Resume.Position>
		
		
			<Resume.Position
				name="IIT Bhubaneshwar"
				link="https://www.iitbbs.ac.in/profile.php/nbpuhan/"
				start="May 2018"
				end="June 2018"
			>
				<Resume.Role name="Research Intern" />
				<Resume.Description>
					<p>
						Worked under the mentorship of Dr. Niladri Bihari Puhan. 
						Implemented and explored the performance of various Convolutional Neural Network (CNN) architectures for Image Classification
					</p>
				</Resume.Description>
			</Resume.Position>
			
			<Resume.Position name="Education" link="http://www.jiit.ac.in/" subtext="Jaypee Institute of Information Technology">
				<Resume.Role
					name="B.Tech Electronis & Communication Engineering"
					start="June 2015"
					end="June 2019"
				/>
			</Resume.Position>
		</Resume>
        </main>
		</div>
	</Layout>
     
)

export default ResumePage
